import { useState, useEffect } from 'react';
const getScreenSize = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}
const DetectScreen = () => {
    const [windowDimensions, setWindowDimensions] = useState(getScreenSize());
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getScreenSize());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
   return windowDimensions
}
export const ScreenSize = {
    'sm':640,
    'md':768,
    'lg':1024,
    'xl':1280,
    '2xl':1536
}
export default DetectScreen